import React, { Component } from 'react';
import Video from '../HomePage/Video';
import FooterPartner from '../../FooterPartner/FooterPartner';
import './Scholarship.scss';
import 'animate.css'

class Scholarship extends Component {
  render() {
    return (
      <section className="section d-flex flex-column align-items-center justify-content-center animate__animated animate__fadeInUp">
          <div id="enrichment" className="info d-flex flex-column align-items-center justify-content-center" data-testid="Enrichment">
            <h2>Scholarships</h2>
          </div>
          <div className="enrichment__container">
            <div className='enrichment-video__container'>
              <Video url="https://www.youtube.com/watch?v=uk00w2EpMtE&t=8s"/>
            </div>
            <div className="enrichment-gl-data__container">
              <p className="text-justify">
              At 606 Academy, we’re proud to offer a limited number of long-term scholarships to dedicated student-athletes who demonstrate passion, commitment, and a drive to improve both on and off the court. These scholarships provide full access to training, leagues, tournaments, and summer camps — but more importantly, they represent an opportunity to grow as leaders through sport. In return, we ask for consistent attendance, academic accountability, and a willingness to give back. Parents will be asked to volunteer and stay engaged through bi-monthly meetings, while athletes must maintain good grades and be a positive reflection of 606 values. As scholarships become more competitive, those who show the most heart, hustle, and desire to contribute will be prioritized.
              </p>
              <a className="btn-lg donate-btn-2" href="https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/40209/" role="button" target=" " >Apply</a>
            </div>
            <div className="gifts">
            <p>
              Thank You to all of our partners and sponsors for helping make kids dreams come true!
              </p>
            </div>
          </div>
          <FooterPartner />
      </section>
    );
  }
}

export default Scholarship;